import LabMetricsReporter from '../lab2/Lab2MetricsReporter';

const danceMetricsReporter = new LabMetricsReporter({
  appName: 'Dance',
});

export default danceMetricsReporter;
